export const baseOrderedListDef = {
  type: 'element',
  name: 'w:abstractNum',
  attributes: {
    'w:abstractNumId': '1',
    'w15:restartNumberingAfterBreak': '0',
  },
  elements: [
    {
      type: 'element',
      name: 'w:nsid',
      attributes: {
        'w:val': '587013BA',
      },
    },
    {
      type: 'element',
      name: 'w:multiLevelType',
      attributes: {
        'w:val': 'hybridMultilevel',
      },
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '0',
        'w:tplc': '0409000F',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'decimal',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '%1.',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '720',
                'w:hanging': '360',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '1',
        'w:tplc': '04090019',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'lowerLetter',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '%2.',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '1440',
                'w:hanging': '360',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '2',
        'w:tplc': '0409001B',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'lowerRoman',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '%3.',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'right',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '2160',
                'w:hanging': '180',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '3',
        'w:tplc': '0409000F',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'decimal',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '%4.',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '2880',
                'w:hanging': '360',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '4',
        'w:tplc': '04090019',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'lowerLetter',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '%5.',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '3600',
                'w:hanging': '360',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '5',
        'w:tplc': '0409001B',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'lowerRoman',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '%6.',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'right',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '4320',
                'w:hanging': '180',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '6',
        'w:tplc': '0409000F',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'decimal',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '%7.',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '5040',
                'w:hanging': '360',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '7',
        'w:tplc': '04090019',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'lowerLetter',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '%8.',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '5760',
                'w:hanging': '360',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '8',
        'w:tplc': '0409001B',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'lowerRoman',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '%9.',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'right',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '6480',
                'w:hanging': '180',
              },
            },
          ],
        },
      ],
    },
  ],
};

export const baseBulletList = {
  type: 'element',
  name: 'w:abstractNum',
  attributes: {
    'w:abstractNumId': '0',
    'w15:restartNumberingAfterBreak': '0',
  },
  elements: [
    {
      type: 'element',
      name: 'w:nsid',
      attributes: {
        'w:val': '16126B07',
      },
    },
    {
      type: 'element',
      name: 'w:multiLevelType',
      attributes: {
        'w:val': 'hybridMultilevel',
      },
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '0',
        'w:tplc': '04090001',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'bullet',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '720',
                'w:hanging': '360',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:rPr',
          elements: [
            {
              type: 'element',
              name: 'w:rFonts',
              attributes: {
                'w:ascii': 'Symbol',
                'w:hAnsi': 'Symbol',
                'w:hint': 'default',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '1',
        'w:tplc': '04090003',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'bullet',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': 'o',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '1440',
                'w:hanging': '360',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:rPr',
          elements: [
            {
              type: 'element',
              name: 'w:rFonts',
              attributes: {
                'w:ascii': 'Courier New',
                'w:hAnsi': 'Courier New',
                'w:cs': 'Courier New',
                'w:hint': 'default',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '2',
        'w:tplc': '04090005',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'bullet',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '2160',
                'w:hanging': '360',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:rPr',
          elements: [
            {
              type: 'element',
              name: 'w:rFonts',
              attributes: {
                'w:ascii': 'Wingdings',
                'w:hAnsi': 'Wingdings',
                'w:hint': 'default',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '3',
        'w:tplc': '04090001',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'bullet',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '2880',
                'w:hanging': '360',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:rPr',
          elements: [
            {
              type: 'element',
              name: 'w:rFonts',
              attributes: {
                'w:ascii': 'Symbol',
                'w:hAnsi': 'Symbol',
                'w:hint': 'default',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '4',
        'w:tplc': '04090003',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'bullet',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': 'o',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '3600',
                'w:hanging': '360',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:rPr',
          elements: [
            {
              type: 'element',
              name: 'w:rFonts',
              attributes: {
                'w:ascii': 'Courier New',
                'w:hAnsi': 'Courier New',
                'w:cs': 'Courier New',
                'w:hint': 'default',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '5',
        'w:tplc': '04090005',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'bullet',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '4320',
                'w:hanging': '360',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:rPr',
          elements: [
            {
              type: 'element',
              name: 'w:rFonts',
              attributes: {
                'w:ascii': 'Wingdings',
                'w:hAnsi': 'Wingdings',
                'w:hint': 'default',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '6',
        'w:tplc': '04090001',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'bullet',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '5040',
                'w:hanging': '360',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:rPr',
          elements: [
            {
              type: 'element',
              name: 'w:rFonts',
              attributes: {
                'w:ascii': 'Symbol',
                'w:hAnsi': 'Symbol',
                'w:hint': 'default',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '7',
        'w:tplc': '04090003',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'bullet',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': 'o',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '5760',
                'w:hanging': '360',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:rPr',
          elements: [
            {
              type: 'element',
              name: 'w:rFonts',
              attributes: {
                'w:ascii': 'Courier New',
                'w:hAnsi': 'Courier New',
                'w:cs': 'Courier New',
                'w:hint': 'default',
              },
            },
          ],
        },
      ],
    },
    {
      type: 'element',
      name: 'w:lvl',
      attributes: {
        'w:ilvl': '8',
        'w:tplc': '04090005',
        'w:tentative': '1',
      },
      elements: [
        {
          type: 'element',
          name: 'w:start',
          attributes: {
            'w:val': '1',
          },
        },
        {
          type: 'element',
          name: 'w:numFmt',
          attributes: {
            'w:val': 'bullet',
          },
        },
        {
          type: 'element',
          name: 'w:lvlText',
          attributes: {
            'w:val': '',
          },
        },
        {
          type: 'element',
          name: 'w:lvlJc',
          attributes: {
            'w:val': 'left',
          },
        },
        {
          type: 'element',
          name: 'w:pPr',
          elements: [
            {
              type: 'element',
              name: 'w:ind',
              attributes: {
                'w:left': '6480',
                'w:hanging': '360',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:rPr',
          elements: [
            {
              type: 'element',
              name: 'w:rFonts',
              attributes: {
                'w:ascii': 'Wingdings',
                'w:hAnsi': 'Wingdings',
                'w:hint': 'default',
              },
            },
          ],
        },
      ],
    },
  ],
};

export const baseNumbering = {
  declaration: {
    attributes: {
      version: '1.0',
      encoding: 'UTF-8',
      standalone: 'yes',
    },
  },
  elements: [
    {
      type: 'element',
      name: 'w:numbering',
      attributes: {
        'xmlns:wpc': 'http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas',
        'xmlns:cx': 'http://schemas.microsoft.com/office/drawing/2014/chartex',
        'xmlns:cx1': 'http://schemas.microsoft.com/office/drawing/2015/9/8/chartex',
        'xmlns:cx2': 'http://schemas.microsoft.com/office/drawing/2015/10/21/chartex',
        'xmlns:cx3': 'http://schemas.microsoft.com/office/drawing/2016/5/9/chartex',
        'xmlns:cx4': 'http://schemas.microsoft.com/office/drawing/2016/5/10/chartex',
        'xmlns:cx5': 'http://schemas.microsoft.com/office/drawing/2016/5/11/chartex',
        'xmlns:cx6': 'http://schemas.microsoft.com/office/drawing/2016/5/12/chartex',
        'xmlns:cx7': 'http://schemas.microsoft.com/office/drawing/2016/5/13/chartex',
        'xmlns:cx8': 'http://schemas.microsoft.com/office/drawing/2016/5/14/chartex',
        'xmlns:mc': 'http://schemas.openxmlformats.org/markup-compatibility/2006',
        'xmlns:aink': 'http://schemas.microsoft.com/office/drawing/2016/ink',
        'xmlns:am3d': 'http://schemas.microsoft.com/office/drawing/2017/model3d',
        'xmlns:o': 'urn:schemas-microsoft-com:office:office',
        'xmlns:oel': 'http://schemas.microsoft.com/office/2019/extlst',
        'xmlns:r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
        'xmlns:m': 'http://schemas.openxmlformats.org/officeDocument/2006/math',
        'xmlns:v': 'urn:schemas-microsoft-com:vml',
        'xmlns:wp14': 'http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing',
        'xmlns:wp': 'http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing',
        'xmlns:w10': 'urn:schemas-microsoft-com:office:word',
        'xmlns:w': 'http://schemas.openxmlformats.org/wordprocessingml/2006/main',
        'xmlns:w14': 'http://schemas.microsoft.com/office/word/2010/wordml',
        'xmlns:w15': 'http://schemas.microsoft.com/office/word/2012/wordml',
        'xmlns:w16cex': 'http://schemas.microsoft.com/office/word/2018/wordml/cex',
        'xmlns:w16cid': 'http://schemas.microsoft.com/office/word/2016/wordml/cid',
        'xmlns:w16': 'http://schemas.microsoft.com/office/word/2018/wordml',
        'xmlns:w16du': 'http://schemas.microsoft.com/office/word/2023/wordml/word16du',
        'xmlns:w16sdtdh': 'http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash',
        'xmlns:w16se': 'http://schemas.microsoft.com/office/word/2015/wordml/symex',
        'xmlns:wpg': 'http://schemas.microsoft.com/office/word/2010/wordprocessingGroup',
        'xmlns:wpi': 'http://schemas.microsoft.com/office/word/2010/wordprocessingInk',
        'xmlns:wne': 'http://schemas.microsoft.com/office/word/2006/wordml',
        'xmlns:wps': 'http://schemas.microsoft.com/office/word/2010/wordprocessingShape',
        'mc:Ignorable': 'w14 w15 w16se w16cid w16 w16cex w16sdtdh w16du wp14',
      },
      elements: [
        {
          type: 'element',
          name: 'w:abstractNum',
          attributes: {
            'w:abstractNumId': '0',
            'w15:restartNumberingAfterBreak': '0',
          },
          elements: [
            {
              type: 'element',
              name: 'w:nsid',
              attributes: {
                'w:val': '16126B07',
              },
            },
            {
              type: 'element',
              name: 'w:multiLevelType',
              attributes: {
                'w:val': 'hybridMultilevel',
              },
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '0',
                'w:tplc': '04090001',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'bullet',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '720',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
                {
                  type: 'element',
                  name: 'w:rPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:rFonts',
                      attributes: {
                        'w:ascii': 'Symbol',
                        'w:hAnsi': 'Symbol',
                        'w:hint': 'default',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '1',
                'w:tplc': '04090003',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'bullet',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': 'o',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '1440',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
                {
                  type: 'element',
                  name: 'w:rPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:rFonts',
                      attributes: {
                        'w:ascii': 'Courier New',
                        'w:hAnsi': 'Courier New',
                        'w:cs': 'Courier New',
                        'w:hint': 'default',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '2',
                'w:tplc': '04090005',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'bullet',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '2160',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
                {
                  type: 'element',
                  name: 'w:rPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:rFonts',
                      attributes: {
                        'w:ascii': 'Wingdings',
                        'w:hAnsi': 'Wingdings',
                        'w:hint': 'default',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '3',
                'w:tplc': '04090001',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'bullet',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '2880',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
                {
                  type: 'element',
                  name: 'w:rPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:rFonts',
                      attributes: {
                        'w:ascii': 'Symbol',
                        'w:hAnsi': 'Symbol',
                        'w:hint': 'default',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '4',
                'w:tplc': '04090003',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'bullet',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': 'o',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '3600',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
                {
                  type: 'element',
                  name: 'w:rPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:rFonts',
                      attributes: {
                        'w:ascii': 'Courier New',
                        'w:hAnsi': 'Courier New',
                        'w:cs': 'Courier New',
                        'w:hint': 'default',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '5',
                'w:tplc': '04090005',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'bullet',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '4320',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
                {
                  type: 'element',
                  name: 'w:rPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:rFonts',
                      attributes: {
                        'w:ascii': 'Wingdings',
                        'w:hAnsi': 'Wingdings',
                        'w:hint': 'default',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '6',
                'w:tplc': '04090001',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'bullet',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '5040',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
                {
                  type: 'element',
                  name: 'w:rPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:rFonts',
                      attributes: {
                        'w:ascii': 'Symbol',
                        'w:hAnsi': 'Symbol',
                        'w:hint': 'default',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '7',
                'w:tplc': '04090003',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'bullet',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': 'o',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '5760',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
                {
                  type: 'element',
                  name: 'w:rPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:rFonts',
                      attributes: {
                        'w:ascii': 'Courier New',
                        'w:hAnsi': 'Courier New',
                        'w:cs': 'Courier New',
                        'w:hint': 'default',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '8',
                'w:tplc': '04090005',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'bullet',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '6480',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
                {
                  type: 'element',
                  name: 'w:rPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:rFonts',
                      attributes: {
                        'w:ascii': 'Wingdings',
                        'w:hAnsi': 'Wingdings',
                        'w:hint': 'default',
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'element',
          name: 'w:abstractNum',
          attributes: {
            'w:abstractNumId': '1',
            'w15:restartNumberingAfterBreak': '0',
          },
          elements: [
            {
              type: 'element',
              name: 'w:nsid',
              attributes: {
                'w:val': '587013BA',
              },
            },
            {
              type: 'element',
              name: 'w:multiLevelType',
              attributes: {
                'w:val': 'hybridMultilevel',
              },
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '0',
                'w:tplc': '0409000F',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'decimal',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '%1.',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '720',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '1',
                'w:tplc': '04090019',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'lowerLetter',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '%2.',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '1440',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '2',
                'w:tplc': '0409001B',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'lowerRoman',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '%3.',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'right',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '2160',
                        'w:hanging': '180',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '3',
                'w:tplc': '0409000F',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'decimal',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '%4.',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '2880',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '4',
                'w:tplc': '04090019',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'lowerLetter',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '%5.',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '3600',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '5',
                'w:tplc': '0409001B',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'lowerRoman',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '%6.',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'right',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '4320',
                        'w:hanging': '180',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '6',
                'w:tplc': '0409000F',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'decimal',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '%7.',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '5040',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '7',
                'w:tplc': '04090019',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'lowerLetter',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '%8.',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'left',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '5760',
                        'w:hanging': '360',
                      },
                    },
                  ],
                },
              ],
            },
            {
              type: 'element',
              name: 'w:lvl',
              attributes: {
                'w:ilvl': '8',
                'w:tplc': '0409001B',
                'w:tentative': '1',
              },
              elements: [
                {
                  type: 'element',
                  name: 'w:start',
                  attributes: {
                    'w:val': '1',
                  },
                },
                {
                  type: 'element',
                  name: 'w:numFmt',
                  attributes: {
                    'w:val': 'lowerRoman',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlText',
                  attributes: {
                    'w:val': '%9.',
                  },
                },
                {
                  type: 'element',
                  name: 'w:lvlJc',
                  attributes: {
                    'w:val': 'right',
                  },
                },
                {
                  type: 'element',
                  name: 'w:pPr',
                  elements: [
                    {
                      type: 'element',
                      name: 'w:ind',
                      attributes: {
                        'w:left': '6480',
                        'w:hanging': '180',
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'element',
          name: 'w:num',
          attributes: {
            'w:numId': '1',
            'w16cid:durableId': '100147962',
          },
          elements: [
            {
              type: 'element',
              name: 'w:abstractNumId',
              attributes: {
                'w:val': '0',
              },
            },
          ],
        },
        {
          type: 'element',
          name: 'w:num',
          attributes: {
            'w:numId': '2',
            'w16cid:durableId': '485517411',
          },
          elements: [
            {
              type: 'element',
              name: 'w:abstractNumId',
              attributes: {
                'w:val': '1',
              },
            },
          ],
        },
      ],
    },
  ],
};
